import { User } from "@core/account/types";
import { PaginationInfo, Time } from "@core/shared/types";
import { atom } from "@mongez/react-atom";
export type Comment = {
  id: number;
  createdAt: Time;
  createdBy: User;
  comment: string;
  likes: number;
  dislikes: number;
  replies: number;
};

export type CommentResponse = {
  comments: Comment[];
  paginationInfo: PaginationInfo | null;
  totalComments: number;
  state: "idle" | "loading" | "loaded" | "error";
};

export const commentsAtom = atom<CommentResponse>({
  key: "comments",
  default: {
    comments: [],
    paginationInfo: null,
    totalComments: 0,
    state: "idle",
  },
});

export const activeCommentAtom = atom<Comment | null>({
  key: "activeComment",
  default: null,
});
